import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

import Modal from "../../../global/Modal";
import HNSColors from "../../../ui library/HNSColors";
import usePaymentsEditModal from "../hooks/usePaymentsEditModal";

import PaymentsActionButtons from "./modal/PaymentsActionButtons";
import PaymentsEditForm from "./modal/PaymentsEditForm";

export default function PaymentsEditModal(props) {
  const { mode = "edit", openModal, paymentData, handleCloseModal } = props;
  const [displayMode, setDisplayMode] = useState(mode);
  const { formValues, isDirty, isSaving, handleFieldOnChange, handleCancel, handleSave } =
    usePaymentsEditModal(props);

  useEffect(() => {
    if (openModal) {
      setDisplayMode(mode);
    }
  }, [mode, openModal]);

  if (mode === "edit" && !paymentData) {
    return null;
  }

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="md">
      <div>
        <div className="px-6 pt-6">
          <Typography className="text-[20px] font-semibold" sx={{ color: HNSColors.neutrals[100] }}>
            {displayMode === "add" ? "Add Payment" : "Edit Payment"}
          </Typography>
        </div>
      <PaymentsEditForm
        formValues={formValues}
        mode={displayMode}
        onChange={handleFieldOnChange}
        openModal={openModal}
      />
        <PaymentsActionButtons
          disableCancel={!isDirty || isSaving}
          disableSave={!isDirty || isSaving}
          handleOnClickCancelBtn={handleCancel}
          handleOnClickSaveButton={handleSave}
        />
      </div>
    </Modal>
  );
}
